const defaultState = () => ({
    item: null,
});

const fieldsModule = {
    base: 'fields',
    namespaced: true,
    state: defaultState(),
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        SET(state, field) {
            state.item = field;
        },
    },
    actions: {
        RESET_STATE({ commit }) {
            commit('RESET_STATE');
        },
        COPY_FIELD({ commit }, field) {
            commit('SET', field);
        },
    },
    getters: {
        clipboard: state => state.item,
    },
};

export default fieldsModule;
